// Bootstrap (vendored via Composer): nur die Komponenten, die das Theme per
// data-bs-* nutzt – Collapse (Navbar), Dropdown (Menüs), Tab (Spielergebnisse).
// Jede Komponente registriert ihre Data-API beim Import selbst.
import "../../vendor/twbs/bootstrap/js/src/collapse.js";
import "../../vendor/twbs/bootstrap/js/src/dropdown.js";
import "../../vendor/twbs/bootstrap/js/src/tab.js";

import GLightbox from "glightbox";
import mobileSliders from "./mobile-slider";



document.addEventListener("DOMContentLoaded", function(){
    mobileSliders()

    // Personen-/Spielerfotos (partials/_person.twig, single-mannschaft.twig)
    if (document.querySelector('.glightbox')) {
        GLightbox({ selector: '.glightbox' })
    }
})
